import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Frete } from 'src/app/models/frete';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FreteService } from 'src/app/services/frete.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { Transportadora } from 'src/app/models/transportadora';
import { TransportadoraService } from 'src/app/services/transportadora.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Modalidade } from 'src/app/models/modalidade';
import { ModalidadeService } from 'src/app/services/modalidade.service';
import { PremissasService } from "../../services/premissas.service";
import { PremissasSistema } from "../../models/premissas-sistema";

// jquery
declare const $: any;

@Component({
  selector: 'app-edita-tabela-de-fretes-modal',
  templateUrl: './edita-tabela-de-fretes-modal.component.html',
  styleUrls: ['./edita-tabela-de-fretes-modal.component.scss']
})
export class EditaTabelaDeFretesModalComponent implements OnInit {
  frete: Frete;
  transportadoras: Transportadora[] = [];
  transportadoraSelecionada = undefined;
  fretes: Frete[] = [];
  opcoesSimNao = [{ id: 1, descricao: 'Sim' }, { id: 0, descricao: 'Não' }];
  exibirModalidade: boolean = false;
  premissas: PremissasSistema;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(public dialogRef: MatDialogRef<EditaTabelaDeFretesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private produtoService: ProdutoService,
    private utilitarioService: UtilitarioService,
    private globalService: GlobalService,
    public dialog: MatDialog,
    private freteService: FreteService,
    private transportadoraService: TransportadoraService,
    private premissasService: PremissasService
  ) {
    this.frete = data.frete;
    this.fretes = data.dados;
    this.transportadoraSelecionada = data.frete.idTransportadora;
    this.exibirModalidade = this.data.exibirModalidade;
  }

  ngOnInit(): void {
    this.buscarPremissas();
    this.buscarTransportadoras();
  }

  buscarPremissas() {
    this.carregandoService.mostra('buscarPremissas');
    this.premissasService.consultarPremissasSistema().subscribe(resp => {
      this.premissas = resp;
      this.carregandoService.esconde('buscarPremissas');
    }, (erro) => {
      this.notificacaoService.erro(erro);
      this.carregandoService.esconde('buscarPremissas');
    });
  }

  buscarTransportadoras() {
    this.carregandoService.mostra('buscarTransportadoras');

    this.transportadoraService.consultarTransportadoras().subscribe(dados => {
      this.transportadoras = dados;

      this.carregandoService.esconde('buscarTransportadoras');
    }, () => {
      this.carregandoService.esconde('buscarTransportadoras');
    });
  }

  voltar() {
    this.dialogRef.close();
  }

  salvar() {
    this.carregandoService.mostra('salvar');
    this.frete.idTransportadora = this.transportadoraSelecionada;
    this.frete.prazoTotal = Number(this.frete.prazoTotal);
    this.frete.prazoDespacho = Number(this.frete.prazoDespacho);
    this.frete.prazoColeta = Number(this.frete.prazoColeta);
    this.frete.freteMinimo = Number(this.frete.freteMinimo);
    this.frete.taxaRural = Number(this.frete.taxaRural);
    this.frete.tda = Number(this.frete.tda);

    this.freteService.salvar(this.frete).subscribe((resp: any) => {
      this.notificacaoService.sucesso('Frete salvo com sucesso!!!');
      this.carregandoService.esconde('salvar');
      this.dialogRef.close(this.frete);

    }, (erro) => {
      this.carregandoService.esconde('salvar');
      this.notificacaoService.erro(erro);
    });
  }

  valida() {
    return (this.frete.prazoTotal !== null && this.frete.prazoTotal !== undefined && this.frete.prazoTotal.toString() !== '' &&
      this.frete.prazoColeta !== null && this.frete.prazoColeta !== undefined && this.frete.prazoColeta.toString() !== '' &&
      this.frete.prazoDespacho !== null && this.frete.prazoDespacho !== undefined && this.frete.prazoDespacho.toString() !== '');
  }
}
